import React from "react";
import { components } from "react-select";
import { REVIEW_GATE_OPTION_TIP_IDS } from "../../recommendations/utils/qaGateValidation";
import { EXEC_SUM_QA_OPTION_COLORS } from "./executiveSummaryQaStatus";

function ExecutiveSummaryReviewGateSelectOption(props) {
    const { data, isDisabled } = props;
    const tipId = isDisabled ? REVIEW_GATE_OPTION_TIP_IDS[data.value] : null;
    const hasTip = isDisabled && tipId && (data.disabledTipHtml || data.disabledTip);
    const color = EXEC_SUM_QA_OPTION_COLORS[data.value];

    return (
        <components.Option {...props}>
            <span
                style={{ color, fontWeight: 600 }}
                {...(hasTip
                    ? {
                          "data-for": tipId,
                          "data-tip": " ",
                          "data-delay-show": "100",
                          "data-effect": "solid",
                          "data-place": "left",
                          "data-background-color": "#1e293b",
                          "data-class": data.disabledTipHtml ? "qa-gate-criteria-tooltip" : "review-gate-option-tooltip",
                          ...(data.disabledTipHtml ? { "data-html": true } : {})
                      }
                    : {})}
            >
                {data.label}
            </span>
        </components.Option>
    );
}

export default ExecutiveSummaryReviewGateSelectOption;
